import graphqlClient from "./graphqlClient";
import { POST_TO_FORGE, CUT_CUSTOM_CLIP } from "./graphql/jared-mutations";
import {
  GET_GAME_FEEDS,
  ASSET_AND_TIME_IN_FEED,
  TIME_IN_FEED
} from "./graphql/jared-queries";

export default class JaredApi {
  postToForge(data, testGroup) {
    return graphqlClient
      .mutate({
        mutation: POST_TO_FORGE,
        variables: { postToForgeRequest: data, testGroup }
      })
      .then(r => {
        return r.postToForge;
      })
      .catch(err => {
        console.log("forge", err);
      });
  }

  getGameFeeds(gamePk, includeInternal) {
    return graphqlClient
      .query({
        query: GET_GAME_FEEDS,
        variables: { gamePk, includeInternal }
      })
      .then(r => {
        return r.data && r.data.gameVideoAssets;
      });
  }

  getTimeInFeed(assetName, start, end, mode) {
    return graphqlClient
      .query({
        query: TIME_IN_FEED,
        variables: { assetName, start, end, mode }
      })
      .then(r => {
        return r.data && r.data.assetOffsets;
      });
  }

  getAssetAndTimeInFeed(gamePk, feedType, start, end) {
    return graphqlClient
      .query({
        query: ASSET_AND_TIME_IN_FEED,
        variables: { gamePk, feedType, start, end }
      })
      .then(r => {
        return r.data && r.data.assetAndOffsets;
      });
  }

  cutCustomClip(clip) {
    return graphqlClient
      .mutate({
        mutation: CUT_CUSTOM_CLIP,
        variables: { userCustomClipRequest: clip }
      })
      .then(r => {
        return r.data && r.data.createUserCustomClip;
      })
      .catch(err => {
        console.log("failed to create custom clip", err);
        return { success: false };
      });
  }
}



// WEBPACK FOOTER //
// ./src/httpClients/JaredApi.js